import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { SnackbarContext } from "../../../../contexts/Snackbar";
import { returnSubmit } from "../../../../enums/queryFunction/Submit";
import { APPOINTMENT_GENERAL, APPOINTMENTS } from "../../../../enums/QueryKeys";
import { HttpStatusCode } from "axios";
import logger from "../../../../utils/logger";

export default function useFinishAppointment(url, id, mutationKeys = null) {
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [open, setOpen] = React.useState(false);

  const [loading, setLoading] = React.useState(false);
  const queryClient = useQueryClient();
  const currentAppointmentKey = APPOINTMENT_GENERAL + id;

  const submitCallback = async (obj) => {
    setLoading(true);
    try {
      const response = await mutateAsync(obj);
      if (response?.status) {
        if (response.status == HttpStatusCode.Ok) {
          return true;
        }
      }
      return false;
    } catch (error) {
      return error;
    }
  };

  function setIsOpen(val) {
    setOpen(val);
  }

  function getIsOpen() {
    return open;
  }

  function updateAppoinmentView(response) {
    if (response) {
      queryClient.setQueryData([currentAppointmentKey], (oldData) => {
        if (!oldData) {
          return oldData;
        }
        return {
          usersPets: oldData.usersPets,
          appointment: response,
        };
      });
    }
  }

  const { mutateAsync } = useMutation({
    mutationFn: (data) => returnSubmit(url, data),
    onSuccess: (response) => {
      if (response?.data) {
        updateAppoinmentView(response?.data);
      } else if (mutationKeys != null) {
        if (Array.isArray(mutationKeys)) {
          mutationKeys.forEach((key) => queryClient.invalidateQueries(key));
        } else {
          queryClient.invalidateQueries(mutationKeys);
        }
      }
      queryClient.invalidateQueries([APPOINTMENTS]);
      handleSnackbar("successMessage", "success");
      setLoading(false);
      setIsOpen(false);
    },
    onError: (error) => {
      logger.error(error);
      handleSnackbar("errorMessage", "error");
      setLoading(false);
    },
  });

  return {
    submitCallback,
    loading,
    setIsOpen,
    getIsOpen,
  };
}
